"use client";
import { isMobile } from "react-device-detect";
import { useAppStore } from "~/store/app-store";
import {
  ListIcon,
  CityIcon,
  AboutIcon,
  ContactIcon,
  ShareIcon,
  AddPhoneIcon,
} from "~/_components/icons";
import { capitalizeWords } from "~/_services/helpers";
import { AppI } from "~/interfaces";
import { useShare } from "~/_hooks/useShare";
import Link from "next/link";

export default function MainMenu() {
  const appStore: AppI = useAppStore((state) => state.app);
  const updateMenu = useAppStore((state) => state.updateMenu);
  const share = useShare();
  const mainNavData = [
    {
      text: "Cities",
      href: "/",
      isMainDomainOnly: true,
      icon: <CityIcon className="mr-3 h-[25px]" />,
    },
    {
      text: "Listings",
      href: "/",
      isSubdomainOnly: true,
      icon: <ListIcon className="mr-3 h-[25px]" />,
    },
    {
      text: "About",
      href: "/about",
      icon: <AboutIcon className="mr-3 h-[25px]" />,
    },
    {
      text: "Contact",
      href: "/contact",
      icon: <ContactIcon className="mr-3 h-[25px]" />,
    },
    {
      text: "Share",
      href: "#",
      icon: <ShareIcon className="mr-3 h-[25px]" />,
      isShare: true,
      isMobileOnly: true,
    },
    {
      text: "Add App to Phone",
      href: "#",
      icon: <AddPhoneIcon className="mr-3 h-[25px]" />,
      isAddPhone: true,
      isMobileOnly: true,
    },
  ];
  const handleShare = () => {
    const endText = appStore.city?.name
      ? capitalizeWords(appStore.city?.name)
      : "a city";
    const subdomain = appStore.city ? `${appStore.city?.name}.` : "";
    share({
      title: "FundayList",
      text: `FundayList is a list of fun unique things to do in ${endText}.`,
      url: `https://${subdomain}fundaylist.com`,
    });
  };

  return (
    <div
      className={`${appStore.menu.isMainMenuActive ? `left-0` : `-left-[275px]`} fun-main-menu transition-left absolute top-14 z-10 flex w-[275px] flex-col bg-beige uppercase text-brown duration-300 ease-linear lg:top-20`}
    >
      {mainNavData.map((nav, i) => {
        // guard for mobile only links
        if (nav.isMobileOnly && !isMobile) return null;
        // guard for city listings homepage
        if (nav.isSubdomainOnly && !appStore.city) return null;
        if (nav.isMainDomainOnly && appStore.city) return null;
        return (
          <Link
            key={`${nav.text}--${i}`}
            href={nav.href}
            className="flex cursor-pointer items-center justify-start border-t border-brown bg-none p-4 font-[600] tracking-[1] opacity-60 transition-all duration-500 hover:bg-lightorange hover:opacity-100"
            aria-label={nav.text}
            onClick={(e) => {
              // Add App to phone
              if (
                nav.isAddPhone &&
                nav.isMobileOnly &&
                typeof window !== "undefined" &&
                window.AddToHomeScreenInstance
              ) {
                e.preventDefault();
                window.AddToHomeScreenInstance.show("en");
              }
              // Share Button
              if (
                nav.isShare &&
                nav.isMobileOnly &&
                typeof window !== "undefined"
              ) {
                handleShare();
                e.preventDefault();
              }
              updateMenu({
                isMainMenuActive: false,
                isSearchActive: false,
              });
            }}
          >
            {nav.icon}
            {nav.text}
          </Link>
        );
      })}
    </div>
  );
}
